export const SPRAY_SUBMISSIONS_SET = 'SPRAY_SUBMISSIONS_SET';

export const SPRAY_SUBMISSIONS_CREATE_REQUESTED =
    'SPRAY_SUBMISSIONS_CREATE_REQUESTED';
export const SPRAY_SUBMISSIONS_CREATE_SUCCEEDED =
    'SPRAY_SUBMISSIONS_CREATE_SUCCEEDED';
export const SPRAY_SUBMISSIONS_CREATE_FAILED =
    'SPRAY_SUBMISSIONS_CREATE_FAILED';

export const SPRAY_SUBMISSIONS_LOAD_REQUESTED =
    'SPRAY_SUBMISSIONS_LOAD_REQUESTED';
export const SPRAY_SUBMISSIONS_LOAD_SUCCEEDED =
    'SPRAY_SUBMISSIONS_LOAD_SUCCEEDED';
export const SPRAY_SUBMISSIONS_LOAD_FAILED = 'SPRAY_SUBMISSIONS_LOAD_FAILED';
export const SPRAY_SUBMISSIONS_LOAD_CANCELED =
    'SPRAY_SUBMISSIONS_LOAD_CANCELED';

export const SPRAY_SUBMISSIONS_NAMESPACE = 'SPRAY_SUBMISSIONS_CREATE';
export const SPRAY_SUBMISSIONS_LOAD_NAMESPACE = 'SPRAY_SUBMISSIONS_LOAD';

export const SPRAY_SUBMISSIONS_DELETE = 'SPRAY_SUBMISSIONS_DELETE';

export const SPRAY_SUBMISSIONS_DELETE_REQUESTED =
    'SPRAY_SUBMISSIONS_DELETE_REQUESTED';
export const SPRAY_SUBMISSIONS_DELETE_SUCCEEDED =
    'SPRAY_SUBMISSIONS_DELETE_SUCCEEDED';
export const SPRAY_SUBMISSIONS_DELETE_FAILED =
    'SPRAY_SUBMISSIONS_DELETE_FAILED';

export const SPRAY_SUBMISSIONS_DELETE_NAMESPACE = 'SPRAY_SUBMISSIONS_DELETE';
